import React from "react";
import { useParams, Link } from "react-router-dom";
import "./BatteryCategory.css";

const batteryData = {
  "inverter-batteries": {
    name: "Inverter Batteries",
    eyebrow: "Home & Commercial Power",
    description: "Built for long backup and deep cycle performance — trusted by homes and businesses across Bihar.",
    batteries: [
      {
        id: "ot1500",
        title: "OT-1500",
        subtitle: "Tall Tubular",
        image: "/ot1500.jpg",
        warranty: "2 Years",
        segment: "Home & Office",
        info: "Compact and efficient backup for small households and offices.",
      },
      {
        id: "ot1800",
        title: "OT-1800",
        subtitle: "Tall Tubular",
        image: "/ot1800.jpg",
        warranty: "3 Years",
        segment: "Home & Office",
        info: "Balanced power output for sustained daily usage.",
      },
      {
        id: "ot2000",
        title: "OT-2000",
        subtitle: "Tall Tubular",
        image: "/ot2000.jpg",
        warranty: "5 Years",
        segment: "Commercial",
        info: "High capacity storage for commercial and industrial needs.",
      },
      {
        id: "os120",
        title: "OS-120",
        subtitle: "Jumbo Tubular",
        image: "/os120.jpg",
        warranty: "5 Years",
        segment: "Commercial",
        info: "Maximum backup power for extended outage protection.",
      },
      {
        id: "os150",
        title: "OS-150",
        subtitle: "Jumbo Tubular",
        image: "/os150.jpg",
        warranty: "5 Years",
        segment: "Commercial",
        info: "Heavy-duty performance with superior cycle life.",
      },
      {
        id: "os200",
        title: "OS-200",
        subtitle: "Jumbo Tubular",
        image: "/os200.jpg",
        warranty: "5 Years",
        segment: "Commercial",
        info: "Top-tier capacity for critical power requirements.",
      },
    ],
  },
  "e-rickshaw-batteries": {
    name: "E-Rickshaw Batteries",
    eyebrow: "Electric Mobility",
    description: "Engineered for the demands of Indian roads — high discharge, fast recovery, and long service life.",
    batteries: [
      {
        id: "120ah",
        title: "ER-120",
        subtitle: "120Ah",
        image: null,
        warranty: "2 Years",
        segment: "E-Rickshaw",
        info: "Lightweight design for maximum range efficiency.",
      },
      {
        id: "130ah",
        title: "ER-130",
        subtitle: "130Ah",
        image: null,
        warranty: "3 Years",
        segment: "E-Rickshaw",
        info: "Enhanced range for longer daily routes.",
      },
      {
        id: "140ah",
        title: "ER-140",
        subtitle: "140Ah",
        image: null,
        warranty: "3 Years",
        segment: "E-Rickshaw",
        info: "Optimal performance under heavy load conditions.",
      },
    ],
  },
  "solar-batteries": {
    name: "Solar Batteries",
    eyebrow: "Clean Energy Storage",
    description: "Deep cycle solar batteries designed to store maximum energy from your solar panels, day after day.",
    batteries: [
      {
        id: "80ah",
        title: "SB-80",
        subtitle: "80Ah",
        image: null,
        warranty: "2 Years",
        segment: "Residential",
        info: "Entry-level solar storage for small installations.",
      },
      {
        id: "100ah",
        title: "SB-100",
        subtitle: "100Ah",
        image: null,
        warranty: "3 Years",
        segment: "Residential",
        info: "Reliable energy storage for home solar systems.",
      },
      {
        id: "150ah",
        title: "SB-150",
        subtitle: "150Ah",
        image: null,
        warranty: "5 Years",
        segment: "Commercial",
        info: "Mid-tier capacity for commercial solar setups.",
      },
      {
        id: "200ah",
        title: "SB-200",
        subtitle: "200Ah",
        image: null,
        warranty: "5 Years",
        segment: "Commercial",
        info: "High-efficiency storage for large solar arrays.",
      },
    ],
  },
  "tractor-batteries": {
    name: "Tractor Batteries",
    eyebrow: "Agricultural Power",
    description: "Robust batteries built to handle the extreme conditions of farm work — reliable starts, every time.",
    batteries: [
      {
        id: "88ah",
        title: "TB-88",
        subtitle: "88Ah",
        image: null,
        warranty: "2 Years",
        segment: "Agriculture",
        info: "Compact power for light-duty tractors.",
      },
      {
        id: "100ah",
        title: "TB-100",
        subtitle: "100Ah",
        image: null,
        warranty: "3 Years",
        segment: "Agriculture",
        info: "Standard duty for mid-size farm equipment.",
      },
      {
        id: "120ah",
        title: "TB-120",
        subtitle: "120Ah",
        image: null,
        warranty: "5 Years",
        segment: "Agriculture",
        info: "Heavy-duty support for large agricultural machinery.",
      },
      {
        id: "150ah",
        title: "TB-150",
        subtitle: "150Ah",
        image: null,
        warranty: "5 Years",
        segment: "Agriculture",
        info: "Maximum durability for the toughest farm conditions.",
      },
    ],
  },
  "automotive-batteries": {
    name: "Automotive Batteries",
    eyebrow: "Vehicle Power",
    description: "High-cranking automotive batteries engineered for reliable starts and consistent performance on Indian roads.",
    batteries: [
      {
        id: "35ah",
        title: "AB-35",
        subtitle: "35Ah",
        image: null,
        warranty: "1 Year",
        segment: "Small Vehicles",
        info: "Compact power for small cars and two-wheelers.",
      },
      {
        id: "65ah",
        title: "AB-65",
        subtitle: "65Ah",
        image: null,
        warranty: "2 Years",
        segment: "Mid-Size Vehicles",
        info: "Dependable reliability for mid-size sedans and SUVs.",
      },
      {
        id: "90ah",
        title: "AB-90",
        subtitle: "90Ah",
        image: null,
        warranty: "3 Years",
        segment: "Trucks",
        info: "High-power for commercial trucks and vans.",
      },
      {
        id: "120ah",
        title: "AB-120",
        subtitle: "120Ah",
        image: null,
        warranty: "5 Years",
        segment: "Heavy-Duty",
        info: "Maximum power for heavy-duty vehicles and fleets.",
      },
    ],
  },
};

// SVG placeholder icon for batteries without images
function BatteryIcon() {
  return (
    <svg viewBox="0 0 80 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="battery-placeholder-icon">
      <rect x="2" y="8" width="72" height="32" rx="4" stroke="#f91919" strokeWidth="2.5" />
      <rect x="74" y="16" width="6" height="16" rx="2" fill="#f91919" opacity="0.5" />
      <rect x="10" y="16" width="20" height="16" rx="2" fill="#f91919" opacity="0.25" />
      <rect x="34" y="16" width="20" height="16" rx="2" fill="#f91919" opacity="0.15" />
    </svg>
  );
}

function BatteryCategory() {
  const { categoryName } = useParams();

  const category = batteryData[categoryName] || {
    name: "Category Not Found",
    eyebrow: "",
    description: "",
    batteries: [],
  };

  const notFound = category.batteries.length === 0;

  return (
    <div className="battery-category-page">

      {/* ── Page Hero ── */}
      <section className="category-hero">
        <div className="category-hero-inner">
          <nav className="breadcrumb" aria-label="Breadcrumb">
            <Link to="/" className="breadcrumb-link">Home</Link>
            <span className="breadcrumb-sep">›</span>
            <Link to="/#products" className="breadcrumb-link">Products</Link>
            <span className="breadcrumb-sep">›</span>
            <span className="breadcrumb-current">{category.name}</span>
          </nav>
          {category.eyebrow && (
            <p className="category-eyebrow">{category.eyebrow}</p>
          )}
          <h1 className="category-heading">{category.name}</h1>
          {category.description && (
            <p className="category-description">{category.description}</p>
          )}
        </div>
      </section>

      {/* ── Battery Grid ── */}
      <section className="category-body">
        <div className="category-container">
          {notFound ? (
            <div className="category-not-found">
              <p>No batteries found in this category.</p>
              <Link to="/" className="back-home-btn">← Back to Home</Link>
            </div>
          ) : (
            <div className="battery-grid">
              {category.batteries.map((battery) => (
                <Link
                  key={battery.id}
                  to={`/battery/${categoryName}/${battery.id}`}
                  className="battery-card"
                >
                  <div className="battery-image-wrap">
                    {battery.image ? (
                      <img
                        src={battery.image}
                        alt={battery.title}
                        className="battery-image"
                      />
                    ) : (
                      <div className="battery-placeholder">
                        <BatteryIcon />
                        <span className="placeholder-label">{battery.subtitle}</span>
                      </div>
                    )}
                  </div>
                  <div className="battery-details">
                    <p className="battery-subtitle">{battery.subtitle}</p>
                    <h3 className="battery-title">{battery.title}</h3>
                    <p className="battery-info">{battery.info}</p>
                    <div className="battery-meta">
                      <span className="battery-warranty">
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{marginRight:5,verticalAlign:'middle'}}>
                          <path d="M6 1L7.5 4.5H11L8.5 6.5L9.5 10L6 8L2.5 10L3.5 6.5L1 4.5H4.5L6 1Z" fill="#f91919"/>
                        </svg>
                        {battery.warranty}
                      </span>
                      <span className="battery-segment">{battery.segment}</span>
                    </div>
                    <div className="battery-cta">View Details <span className="cta-arrow">→</span></div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>

    </div>
  );
}

export default BatteryCategory;
